module.exports = __webpack_public_path__ + "img/Illustaions.46af914b.png";